import Constants from '../constants';
import { restActionCreator } from './index';
import { ACTION_SUCCESS } from '../constants/action-status';
import Url from 'url';
import { replace } from 'connected-react-router';
import { ANSWER_TYPE } from '../constants/custom-content';
import { answerForwardToQuestion } from './answer';

const COMMENT_HASH = '#comment-';

const parseCommentFromHash = (hash) => {
	if (hash && hash.startsWith(COMMENT_HASH)) {
		return hash.substr(COMMENT_HASH.length);
	}
	return null;
};

// Make this know of dispatch and dispatch an redirect action from here
const forwardRouteToContent = (contentId, contentPlugin, hash) => (dispatch) => {
	const commentId = parseCommentFromHash(hash);

	//  All redirect checks go here:
	//  Forward to a QUESTION, unless we find it's an answer
	if (contentId && contentId !== '0') {
		if (contentPlugin === ANSWER_TYPE) {
			// Forward to an ANSWER
			// Do not look up question ID here, because application is not fully initialized
			dispatch(answerForwardToQuestion(contentId, commentId));
		} else {
			if (commentId) {
				dispatch(replace(`/questions/${contentId}/comment/${commentId}`));
			} else {
				dispatch(replace(`/questions/${contentId}`));
			}
		}
	}
};

export const forwardRoute = (contentId, contentPlugin) => (dispatch) => {
	// fetch the host location to parse the hash (comment links will have commentId in the hash)
	return dispatch(
		restActionCreator(
			() =>
				new Promise((resolve) => {
					AP.getLocation((location) => {
						const urlData = Url.parse(location, true);
						resolve({
							...urlData,
						});
					});
				}),
			Constants.FORWARD_ROUTE,
		),
	).then((actionResult) => {
		if (actionResult.type.includes(ACTION_SUCCESS)) {
			const locationData = actionResult.payload.results;
			forwardRouteToContent(contentId, contentPlugin, locationData.hash)(dispatch);
		}
	});
};
